module.exports = __webpack_public_path__ + "img/home-hero_cn-4.920a098.jpg";